import React from "react";
import { useAppText } from "src/commun/composants/AppText";
import { useFormikContext } from "formik";
import { VerificationMail } from "src/pages/finalisation/etapes/verificationMail/codeMailSend/useValidationSchemaMail";
import AppRow from "src/commun/composants/grille/AppRow";
import AppCol from "src/commun/composants/grille/AppCol";
import AppInputFormik from "src/commun/composants/formulaire/formik/fields/AppInputFormik";
import { useFinalisation } from "src/pages/finalisation/FinalisationContext";
import TitreField from "src/commun/composants/formulaire/fields/TitreField";
import AppCheckboxFormik from "src/commun/composants/formulaire/formik/fields/AppCheckboxFormik";
import AppDatePickerFormik from "src/commun/composants/formulaire/formik/fields/AppDatePickerFormik";
import AppInputPasswordFormik from "src/commun/composants/formulaire/formik/fields/AppInputPasswordFormik";
import { useAppState } from "src/app/state/StateProvider";
import usePasswordCriterias from "src/commun/hooks/usePasswordCriterias";
import styles from "src/pages/infoperso/infoperso/InfoPersoUpdateFormContent.scss";
import TelephoneField from "src/commun/composants/formulaire/fields/TelephoneField";


const InfoPersoFormContent = () => {

  const passwordCriterias = usePasswordCriterias();
  const [{ cguLink }] = useAppState();
  const { tString } = useAppText();
  const { submitCount, submitForm } = useFormikContext<VerificationMail>();

  const [value] = useFinalisation();

  return (
    <AppRow>
      <AppCol md={5}>
        <label>{tString("migration.step.3.intro")}</label>
      </AppCol>
      <AppCol md={6}>
        <div className="mb-3 ">
          <label>{tString("compte.mon.profile.email")} : {value.etapes[0].data.email}</label>
        </div>

        {value.etapes[1].data.mobileNumber && (
          <div className="mb-3 ">
            <label>{tString("compte.mon.profile.mobile")} : {value.etapes[1].data.mobileNumber}</label>
          </div>
        )}

        <div className="input mt-5 mb-5 ">
          <TitreField defaultValue={"compte.mon.profile.infoPersonnel.civilite.obligatoire"}/>
        </div>
        <div className="input mt-3 mb-5 ">
          <AppInputFormik
            name="lastName"
            type="text"
            formulaireSoumis={submitCount > 0}
          />
          <label>{tString("compte.mon.profile.infoPersonnel.nom")}</label>
        </div>
        <div className="input mt-3 mb-2">
          <AppInputFormik
            name="firstName"
            type="text"
            formulaireSoumis={submitCount > 0}
          />
          <label>{tString("compte.mon.profile.infoPersonnel.prenom")}</label>
        </div>

        <AppDatePickerFormik formulaireSoumis={submitCount > 0} name="birthdate" label={tString("compte.mon.profile.infoPersonnel.dateNaissance")}/>

        <div className="input mt-5 mb-2">
          <span className={styles.fieldLabel}>{tString("compte.mon.profile.infoPersonnel.telephonePro")}</span>
          <TelephoneField name="telephonePro" />
        </div>

        <AppInputPasswordFormik
          name="password"
          label={tString("compte.mon.profile.password.nouveau")}
          criterias={passwordCriterias}
          formulaireSoumis={submitCount > 0}
        />

        <div className="mt-3">
          <AppInputPasswordFormik
            name="confirmationPassword"
            label={tString("compte.mon.profile.password.nouveau.confirm")}
            formulaireSoumis={submitCount > 0}
          />
        </div>

        <div className="mt-5 paragraph--gray">
          <AppCheckboxFormik name="acceptCGU" value={"false"}
                             label={<label>{tString("cgu.accepte.lu")}<a className="appLink" href={cguLink} rel="noopener noreferrer"
                                                                         target="_blank">{tString("cgu.accepte.lu.lien")}</a></label>}/>
        </div>

        <input
          className="btn__primary mt-3  btn--full--xs"
          type="submit"
          name="submit"
          onClick={submitForm}
          value={tString("action.mettre.aJour.compte")}
        />

      </AppCol>
    </AppRow>
  );
};

export default InfoPersoFormContent;